const getDefaultApiBaseUrl = () => {
  if (typeof window === "undefined") {
    return "http://localhost:5000";
  }

  const { protocol, hostname, origin, port } = window.location;
  const isLocalDev = ["localhost", "127.0.0.1"].includes(hostname);

  if (isLocalDev && port === "3000") {
    return `${protocol}//${hostname}:5000`;
  }

  return origin;
};

export const API_BASE_URL = (
  process.env.REACT_APP_BASE_URL ||
  getDefaultApiBaseUrl()
).replace(/\/$/, "");

export const API_URL = (
  process.env.REACT_APP_API_URL ||
  `${API_BASE_URL}/api`
).replace(/\/$/, "");

export const buildApiUrl = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
